import { Box, Stack, Typography } from '@mui/material';
import { useCallback } from 'react';
import type { MatchStatsLabelProps } from './MatchStatsLabel.types';

export const MatchStatsLabel: React.FC<MatchStatsLabelProps> = ({
  label,
  team1Value,
  team2Value,
  usePercentage,
  awayTeamColor,
  homeTeamColor,
}) => {
  const getPercentage = useCallback(() => {
    return team1Value === 0 && team2Value === 0
      ? [50, 50]
      : [
          (team2Value / (team1Value + team2Value)) * 100,
          (team1Value / (team1Value + team2Value)) * 100,
        ];
  }, [team1Value, team2Value]);

  const [team2Percentage, team1Percentage] = getPercentage();
  return (
    <Stack gap={0.5}>
      <Stack
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center">
        <Typography variant="paragraphMdEmphasis">
          {team1Value}
          {usePercentage && '%'}
        </Typography>
        <Typography variant="paragraphSmEmphasis" textTransform="uppercase">
          {label}
        </Typography>
        <Typography variant="paragraphMdEmphasis">
          {team2Value}
          {usePercentage && '%'}
        </Typography>
      </Stack>
      <Stack
        height={(theme) => theme.spacing(0.75)}
        width="100%"
        position="relative">
        <Box
          width="100%"
          height="100%"
          position="absolute"
          right={0}
          sx={{
            backgroundImage: () =>
              `linear-gradient(${homeTeamColor},${homeTeamColor})`,
            backgroundPosition: 'left',
            backgroundRepeat: 'no-repeat',
            backgroundSize: `calc(${team1Percentage}% - 5px) 100%`,
            transition: 'background-size .6s ease-in-out',
          }}
        />
        <Box
          width="100%"
          height="100%"
          position="absolute"
          right={0}
          sx={{
            backgroundImage: () =>
              `linear-gradient(${awayTeamColor},${awayTeamColor})`,
            backgroundPosition: 'right',
            backgroundRepeat: 'no-repeat',
            backgroundSize: `${team2Percentage}% 100%`,
            transition: 'background-size .6s ease-in-out',
          }}
        />
      </Stack>
    </Stack>
  );
};
